var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"text-input",attrs:{"type":"text"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)},"keydown":function($event){return $event.stopPropagation()}}})}
var staticRenderFns = []

export { render, staticRenderFns }